module.exports = __webpack_public_path__ + "img/fotobartodzieje.a0190701.jpg";